import { observer } from "mobx-react-lite"
import { Input, Switch, Select, Button, Col } from "antd"
import i from "../translations/i"

export const AdditionalFields = observer(({fields} : any) => {

  return(
    <>
      {fields.map((el: any) => el.field ? (
        <Col span={12}>
          {el.field.field_type === 'input' ? <AF_Input field={el} /> : <></>}
          {el.field.field_type === 'text' ? <AF_Text field={el} /> : <></>}
          {el.field.field_type === 'phone' ? <AF_Input field={el} /> : <></>}
          {el.field.field_type === 'email' ? <AF_Input field={el} /> : <></>}
          {el.field.field_type === 'checkbox' ? <AF_Switch field={el} /> : <></>}
          {el.field.field_type === 'radio' ? <AF_Radio field={el} /> : <></>}
          {el.field.field_type === 'select' ? <AF_Select field={el} /> : <></>}
          {el.field.field_type === 'file' ? <AF_File field={el} /> : <></>}
        </Col>
      ) : <></>)}
    </>
  )
})

const AF_Input = observer(({field} : any) => {

  return(
    <>
      <label>{field.field.field_name ?? field.field.placeholder ?? 'none'}</label>
      <Input
        value={field.value}
        disabled
      />
    </>
  )
})

const AF_Text = observer(({field} : any) => {

  return(
    <>
      <label>{field.field.field_name ?? field.field.placeholder ?? 'none'}</label>
      <Input.TextArea
        value={field.value}
        disabled
      />
    </>
  )
})

const AF_Switch = observer(({field} : any) => {

  return(
    <>
      <label>{field.field.field_name ?? field.field.placeholder ?? 'none'}</label>
      <Switch checked={field.value} checkedChildren={i.t('def:yes')} unCheckedChildren={i.t('def:no')} disabled />
    </>
  )
})

const AF_Radio = observer(({field} : any) => {

  return(
    <>
      <label>{field.field.field_name ?? field.field.placeholder ?? 'none'}</label>
      <Select
        options={field.field.options.map((e: any) => ({
          label: e.value,
          value: e.id
        }))}
        value={Number(field.value)}
        style={{ width: '100%' }}
      />
    </>
  )
})

const AF_Select = observer(({field} : any) => {

  return(
    <>
      <label>{field.field.field_name ?? field.field.placeholder ?? 'none'}</label>
      <Select
        options={field.field.options.map((e: any) => ({
          label: e.value,
          value: e.value
        }))}
        value={field.value.split(",")}
        style={{ width: '100%' }}
        mode="multiple"
      />
    </>
  )
})

const AF_File = observer(({field} : any) => {

  return(
    <>
      <label>{field.field.field_name ?? field.field.placeholder ?? 'none'}</label>
      <Button href={`${field.file.base}${field.file.uri}`} target="_blank">{i.t('additionalFields:download')}</Button>
    </>
  )
})